var Marionette = require('backbone.marionette');
var CommonUtils = require('../../utils/common-utils.js');
var RelationTypesCollection = require('../../collections/relation-types-collection');

var RelationTypeItem = Marionette.View.extend({
    tagName: 'tr',
    template: require('../../templates/relationtypes/relationtype-item.html'),

    initialize : function (options) {
    },

    templateContext: function(){
        var that = this;
        var description = that.model.get('description');
        return {
            fullDescription: description,
            description: description.length > 100 ? (description.substr(0, 97) + '...') : description
        }
    },

    className: function() {
        var filter = this.getOption('filter');
        var utils = new CommonUtils();
        if (utils.stringContains(this.model.attributes.name, filter) || utils.stringContains(this.model.attributes.description, filter)
            || utils.stringContains(this.model.attributes.parentType, filter) || utils.stringContains(this.model.attributes.childType, filter)) {
            return '';
        }
        else {
            return 'hidden';
        }
    },

    onRender: function() {
        this.$('[data-toggle="tooltip"]').tooltip();
    }
});

var RelationTypesListView = Marionette.CompositeView.extend({
    template: require('../../templates/relationtypes/relationtypes-table.html'),
    childViewContainer:'#relationtypes-list',
    childView: RelationTypeItem,
    collection: new RelationTypesCollection(),

    filter: '',

    collectionEvents: {
        request: 'showLoading',
        sync: 'hideLoading',
        error: 'logError'
    },

    childViewOptions: function() {
        return {filter: this.filter};
    },

    initialize: function(options){
        this.filter = this.getOption('filter');
        if (this.getOption('relationtypes')) {
            this.collection = this.getOption('relationtypes');
        }
        else {
            this.collection.fetch();
        }

    },

    setFilter: function(filter) {
        this.filter = filter;
        this.render();
        this.hideLoading();
    },

    showLoading: function() {
        this.$('.loading').show();
    },

    hideLoading: function() {
        this.$('.loading').hide();
    },

    logError: function(obj, response) {
        this.$('.loading').hide();
        this.triggerMethod('server:error', response.responseText);
    }
});


module.exports = RelationTypesListView;


//////////////////
// WEBPACK FOOTER
// ./app/views/relationtypes/relationtype-list-view.js
// module id = 432
// module chunks = 0